module.exports = __webpack_public_path__ + "img/bg-blue-3.b684ce0f.png";